import React from "react";
import { Card, CardHeader, Table, Badge } from "reactstrap";
import Loader from "components/Loader.js";

const RecentCampaignsTable = ({ data, loading }) => {
    const campaigns = data?.campaigns?.recent || [];

    const getPlatformColor = (platform) => {
        return platform === 'ActiveCampaign' ? 'primary' : 'info';
    };

    const getPerformanceColor = (openRate) => {
        if (openRate >= 25) return 'success';
        if (openRate >= 15) return 'warning';
        return 'danger';
    };



    return (
        <Card className="shadow">
            <CardHeader className="border-0">
                <h3 className="mb-0">Últimas Campanhas Enviadas</h3>
            </CardHeader>

            <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'hidden' }}>
                <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                        <tr>
                            <th scope="col" style={{ width: '25%' }}>Campanha</th>
                            <th scope="col" style={{ width: '10%' }}>Plataforma</th>
                            <th scope="col" style={{ width: '15%' }}>Conta</th>
                            <th scope="col" style={{ width: '10%' }}>Enviados</th>
                            <th scope="col" style={{ width: '10%' }}>Taxa Abertura</th>
                            <th scope="col" style={{ width: '10%', paddingRight: '1.5rem' }}>Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="6" className="text-center p-0">
                                    <Loader variant="card" size="sm" />
                                </td>
                            </tr>
                        ) : campaigns.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="text-center p-4 text-muted">
                                    Nenhuma campanha recente
                                </td>
                            </tr>
                        ) : (
                            campaigns.map((campaign, index) => (
                                <tr key={index}>
                                    <th scope="row" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        <span className="mb-0 text-sm">
                                            {campaign.name}
                                        </span>
                                    </th>
                                    <td>
                                        <Badge color={getPlatformColor(campaign.platform)} pill>
                                            {campaign.platform === 'ActiveCampaign' ? 'AC' : 'RD'}
                                        </Badge>
                                    </td>
                                    <td style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        <span className="text-sm text-muted">
                                            {campaign.account}
                                        </span>
                                    </td>
                                    <td>
                                        {campaign.sends.toLocaleString()}
                                    </td>
                                    <td>
                                        <Badge color={getPerformanceColor(campaign.openRate)} pill>
                                            {campaign.openRate.toFixed(1)}%
                                        </Badge>
                                    </td>

                                    <td style={{ paddingRight: '1.5rem' }}>
                                        {new Date(campaign.sentAt).toLocaleDateString('pt-BR')}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>

        </Card >
    );
};

export default RecentCampaignsTable;
